import React, { useEffect, useState } from "react";
import { DropDownList } from "@progress/kendo-react-dropdowns";
import { Slider, SliderLabel } from "@progress/kendo-react-inputs";
import {
  APIProvider,
  Map,
  Circle,
  Marker,
  InfoWindow,
  useMapsLibrary,
} from "@vis.gl/react-google-maps";
import { Container } from "react-bootstrap";
import Requests from "../../Requests";

const API_KEY = "AIzaSyBXH7FhFIS2Nuut_W6ww3mRvEJIAGF0_x0";
const METERS_PER_MILE = 1609.344;

const containerStyle = {
  width: "auto",
  height: "70vh",
};

const geocodeAddress = (geocoder, address, index) =>
  new Promise((resolve) => {
    geocoder.geocode({ address }, (results, status) => {
      if (status !== "OK" || !results?.[0]) {
        console.error("Geocoding error", status);
        resolve(null);
        return;
      }

      const loc = results[0].geometry.location;
      resolve({
        id: index + 1,
        name: results[0].formatted_address,
        latitude: loc.lat(),
        longitude: loc.lng(),
      });
    });
  });

function MapContent({ core }) {
  // useMapsLibrary triggers async loading of the geocoding library and
  // re-renders this component once it is ready.
  const geocodingLib = useMapsLibrary("geocoding");

  const [selectedMarker, setSelectedMarker] = useState(null);
  const [radius, setRadius] = useState(1);
  const [markers, setMarkers] = useState([]);
  const [place, setPlace] = useState([]);
  const [lat, setLat] = useState(0);
  const [lng, setLng] = useState(0);
  const [zoom, setZoom] = useState(20);
  const [selectedPlaceasOption, setSelectedPlaceasOption] = useState();

  useEffect(() => {
    if (!geocodingLib) return;

    let cancelled = false;
    const geocoder = new geocodingLib.Geocoder();

    Requests.doRestRequest(
      core,
      "/app/ff1ecbb7-3a45-4966-b38c-bf203f171423/command/delegate/GetContactAddress",
      {},
      "get",
      (response) => {
        Promise.all(
          (response?.addressData || []).map((item, index) =>
            geocodeAddress(geocoder, item, index)
          )
        ).then((resolvedPlaces) => {
          if (cancelled) return;

          const nextPlaces = resolvedPlaces.filter(Boolean).reverse();
          setPlace(nextPlaces);
          setMarkers(nextPlaces);

          if (nextPlaces[0]) {
            setLat(nextPlaces[0].latitude);
            setLng(nextPlaces[0].longitude);
            setSelectedPlaceasOption(nextPlaces[0].name);
          }
        });
      },
      (error) => {
        console.log("error " + error);
      }
    );

    return () => {
      cancelled = true;
    };
  }, [geocodingLib, core]);

  const handleChange = (e) => {
    place.forEach((i) => {
      if (e.value === i.name) {
        setLat(i.latitude);
        setLng(i.longitude);
      }
    });
    setSelectedPlaceasOption(e.value);
  };

  const handleChangeRadius = (value) => {
    if (value > 100) setZoom(2);
    else if (!value) setZoom(20);
    else if (value >= 100) setZoom(5);
    else if (value >= 75) setZoom(6);
    else if (value >= 50) setZoom(8);
    else if (value >= 25) setZoom(10);
    else if (value >= 1) setZoom(12);
    else setZoom(20);
  };

  return (
    <Container fluid>
      <div className="mt-4">
        <span className="pr-4">Select Location:</span>
        <DropDownList
          data={place.map((item) => item.name)}
          onChange={handleChange}
          style={{ width: "25vw" }}
          value={selectedPlaceasOption}
        />
        <div className="mt-4">
          <Map
            style={containerStyle}
            center={{ lat, lng }}
            zoom={zoom}
          >
            <Circle
              center={{ lat, lng }}
              radius={(parseFloat(radius) || 0) * METERS_PER_MILE}
              fillColor="red"
              strokeColor="red"
              fillOpacity={0.35}
              strokeOpacity={0.8}
              strokeWeight={2}
              clickable={false}
              draggable={false}
              editable={false}
            />
            {markers.map((p) => (
              <Marker
                key={p.id}
                position={{ lat: p.latitude, lng: p.longitude }}
                onClick={() => setSelectedMarker(p)}
              />
            ))}
            {selectedMarker && (
              <InfoWindow
                position={{
                  lat: selectedMarker.latitude,
                  lng: selectedMarker.longitude,
                }}
                onClose={() => setSelectedMarker(null)}
              >
                <>
                  <p>{selectedMarker.name}</p>
                  <p>Latitude: {selectedMarker.latitude}</p>
                  <p>Longitude: {selectedMarker.longitude}</p>
                </>
              </InfoWindow>
            )}
          </Map>
        </div>
        <div className="mt-3 float-right">
          <Slider
            style={{ width: "25vw" }}
            buttons={true}
            step={25}
            defaultValue={1}
            min={0}
            max={100}
            onChange={(e) => {
              setRadius(e.value);
              handleChangeRadius(e.value);
            }}
          >
            {[0, 25, 50, 75, 100].map((i) => (
              <SliderLabel title={i.toString()} key={i} position={i}>
                {i} Miles
              </SliderLabel>
            ))}
          </Slider>
        </div>
      </div>
    </Container>
  );
}

export default function CustomMapComponent(props) {
  if (!API_KEY) {
    console.error("GOOGLE_MAPS_API_KEY is not configured.");
    return null;
  }

  return (
    <APIProvider apiKey={API_KEY} authReferrerPolicy="origin">
      <MapContent core={props.core} />
    </APIProvider>
  );
}
